import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function Register() {
  const [name, setName] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleRegister() {
    if (!name || !email || !password) { setError('Please fill in all fields.'); return }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return }
    setLoading(true)
    setError(null)
    const { data, error: signUpError } = await supabase.auth.signUp({ email, password })
    if (signUpError) { setError(signUpError.message); setLoading(false); return }
    const { error: profileError } = await supabase.from('users').insert({
      id: data.user.id, name, email,
      display_name: displayName.trim() || null,
      phone: phone ? `+27${phone.replace(/^0/, '')}` : null
    })
    if (profileError) { setError('Account created but profile setup failed. Please contact support.'); setLoading(false); return }
    window.location.href = '/'
  }

  return (
    <div>
      <nav className="topnav">
        <a href="/" className="topnav-logo">PREDICTA</a>
        <a href="/login" className="btn btn-secondary" style={{ padding: '7px 16px', fontSize: '13px' }}>Log in</a>
      </nav>

      <div className="container-narrow">
        <div style={{ textAlign: 'center', paddingTop: '48px', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '36px', marginBottom: '8px' }}>Create your account</h1>
          <p style={{ color: 'var(--text-2)' }}>Join Predicta and enter the World Cup 2026 competition</p>
        </div>

        <div className="card">
          {error && (
            <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: '16px' }}>
              <p style={{ color: 'var(--red)', fontSize: '13px' }}>{error}</p>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Full name</label>
              <input type="text" placeholder="John Doe" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>
                Leaderboard name <span style={{ color: 'var(--text-3)', fontWeight: '400', textTransform: 'none', letterSpacing: 'normal' }}>(optional)</span>
              </label>
              <input type="text" placeholder="e.g. GoalMachine, TacticalGenius, LuckyPunter" value={displayName} onChange={e => setDisplayName(e.target.value)} maxLength={30} />
              <p style={{ fontSize: '11px', color: 'var(--text-3)', marginTop: '5px' }}>The name that appears on the public leaderboard. Leave blank to use your real name.</p>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Email</label>
              <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Password</label>
              <input type="password" placeholder="Min 6 characters" value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>
                WhatsApp number <span style={{ color: 'var(--text-3)', fontWeight: '400', textTransform: 'none', letterSpacing: 'normal' }}>(optional)</span>
              </label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '10px 14px', fontSize: '14px', color: 'var(--text-2)', whiteSpace: 'nowrap' }}>+27</span>
                <input type="tel" placeholder="081 234 5678" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} style={{ flex: 1 }} />
              </div>
              <p style={{ fontSize: '11px', color: 'var(--text-3)', marginTop: '5px' }}>Used only to notify you about competition updates. Never shared.</p>
            </div>
          </div>
          <button className="btn btn-primary" onClick={handleRegister} disabled={loading} style={{ width: '100%', marginTop: '20px', padding: '13px', fontSize: '15px' }}>
            {loading ? 'Creating account...' : 'Create account'}
          </button>
          <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: 'var(--text-2)' }}>
            Already have an account? <a href="/login" style={{ color: 'var(--gold)', fontWeight: '600' }}>Log in</a>
          </p>
        </div>
      </div>
    </div>
  )
}